/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_MASTER_DEPARTMENT_SUCCESS,
  LOAD_MASTER_DEPARTMENT_ERROR,
  LOAD_MASTER_DESIGNATION_SUCCESS,
  LOAD_MASTER_DESIGNATION_ERROR,
  LOAD_ROLE_SUCCESS,
  LOAD_ROLE_ERROR,
  LOAD_LOGINSHIFTS_SUCCESS,
  LOAD_LOGINSHIFTS_ERROR,
  LOAD_LOP_SETTING_SUCCESS,
  LOAD_LOP_SETTING_ERROR,
   LOAD_MASTER_HOLIDAY_SUCCESS,
    LOAD_MASTER_HOLIDAY_ERROR
} from "./constants";

const initialState = {
  departmentList: [],
  designationList: [],
  roleList: {},
  loginShiftList: [],
  lopSettingList: [],
  masterHolidayList:[],
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    departmentList,
    loginShiftList,
    designationList,
    lopSettingList,
    roleList,
    masterHolidayList,
    error,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_MASTER_DEPARTMENT_SUCCESS:
        draft.departmentList = departmentList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_MASTER_DESIGNATION_SUCCESS:
        draft.designationList = designationList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_ROLE_SUCCESS:
        draft.roleList = roleList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_LOGINSHIFTS_SUCCESS:
        draft.loginShiftList = loginShiftList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_LOP_SETTING_SUCCESS:
        draft.lopSettingList = lopSettingList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_MASTER_HOLIDAY_SUCCESS:
        draft.masterHolidayList = masterHolidayList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_MASTER_DESIGNATION_ERROR:
      case LOAD_MASTER_DEPARTMENT_ERROR:
      case LOAD_MASTER_HOLIDAY_ERROR:
      case LOAD_ROLE_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      case LOAD_LOGINSHIFTS_ERROR:
      case LOAD_LOP_SETTING_ERROR:
        draft.error = error;
        draft.success = false;
        break;

      default:
        return state;
    }
  });
};

export default Reducer;
